export const getFileExtension = fileName => {
  if (fileName.indexOf('.') === -1) {
    return null;
  }

  const extSplittedFileName = fileName.split('.');

  return `.${extSplittedFileName[
    extSplittedFileName.length - 1
  ].toLowerCase()}`;
};
